import { useState, useEffect } from 'react';
import { useAuthContext } from './useAuthContext'

export const usePublicFetch = (url) => {
  const [data, setData] = useState(null);
  const [isPending, setIsPending] = useState(true);
  const [error, setError] = useState(null);
  const {user} = useAuthContext();

  useEffect(() => {
    const abortCont = new AbortController();
    const token = user.data.token;
    console.log('token', token)

    setTimeout(() => {
        fetch(url, {
          method: 'GET',
          headers: {'Authorization': `Bearer ${token}`}
        })
      .then(res => {
        if (!res.ok) {
          throw Error('could not fetch the data for that resource');
        } 
        return res.json();
      })
      .then(data => {
        setIsPending(false);
        setData(data);
        setError(null);
      })
      .catch(err => {
        if (err.name === 'AbortError') {
          //console.log('fetch aborted')
        } else {
          // auto catches network / connection error
          setIsPending(false);
          setError(err.message);
        }
      })
    }, 1000);

    // abort the fetch
    return () => abortCont.abort();
  }, [url])

  return { data, setData, isPending, error };
}